import styled from "styled-components";
import { colors } from "../../../theme/theme";

export const CustomPagination = styled.div`
    .page-link{
        color: ${colors.greyscale.darker_grey};
    }
    
    .page-item.active .page-link {
        background-color: ${colors.mainColors.verde_dstore};
        border-color: ${colors.mainColors.verde_dstore};
    }
`